<ng-container *ngIf="form !== null">
  <div class="cf-dlg">

    <!-- HEADER -->
    <div class="cf-dlg-header">
      <div class="cf-dlg-icon"><mat-icon>receipt</mat-icon></div>
      <div>
        <h2 class="cf-dlg-title">Nuevo gasto de empleado</h2>
        <p class="cf-dlg-subtitle">Adjunta la imagen o documento del gasto</p>
      </div>
    </div>

    <!-- BODY -->
    <div class="cf-dlg-body" style="padding:0;">
      <mat-tab-group animationDuration="0ms">

        <!-- TAB: Imagen -->
        <mat-tab label="Imagen (JPG / PNG)">
          <form [formGroup]="form" style="padding: 16px 24px;">
            <div class="cf-dlg-row">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Empleado</mat-label>
                <mat-select formControlName="employees_Id">
                  <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">{{ e.name }}</mat-option>
                </mat-select>
                <mat-hint>Empleado al que se asociará el archivo</mat-hint>
                <mat-error *ngIf="form.controls['employees_Id'].hasError('required')">
                  El empleado es <strong>obligatorio</strong>
                </mat-error>
              </mat-form-field>
              <app-select class="w-100" [formControl]="form.get('tipoGasto')"
                [config]="{ label: 'Tipo de gasto', options: tipoGastoOptions }"></app-select>
            </div>
            <span class="cf-dlg-section__label">Archivo</span>
            <div class="cf-dlg-upload-zone">
              <label class="cf-dlg-upload-btn" for="img-input-form">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path d="M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.1 0-40 17.9-40 40s17.9 40 40 40 40-17.9 40-40-17.9-40-40-40zM96 352h320v-80l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0L192 304l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L96 304v48z"/>
                </svg>
                Seleccionar imagen
              </label>
            </div>
            <input id="img-input-form" type="file" (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png" style="display:none">
          </form>
        </mat-tab>

        <!-- TAB: PDF -->
        <mat-tab label="Documento (PDF)">
          <form [formGroup]="formDoc" style="padding: 16px 24px;">
            <div class="cf-dlg-row">
              <mat-form-field class="w-100" appearance="outline">
                <mat-label>Empleado</mat-label>
                <mat-select formControlName="employees_Id">
                  <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">{{ e.name }}</mat-option>
                </mat-select>
                <mat-hint>Empleado al que se asociará el archivo</mat-hint>
                <mat-error *ngIf="formDoc.controls['employees_Id'].hasError('required')">
                  El empleado es <strong>obligatorio</strong>
                </mat-error>
              </mat-form-field>
              <app-select class="w-100" [formControl]="formDoc.get('tipoGasto')"
                [config]="{ label: 'Tipo de gasto', options: tipoGastoOptions }"></app-select>
            </div>
            <span class="cf-dlg-section__label">Archivo</span>
            <div class="cf-dlg-upload-zone">
              <label class="cf-dlg-upload-btn" for="pdf-input-form">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                  <path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"/>
                </svg>
                Seleccionar PDF
              </label>
            </div>
            <input id="pdf-input-form" type="file" (change)="onPDFSelected($event)" accept="application/PDF" style="display:none">
          </form>
        </mat-tab>

      </mat-tab-group>
    </div>

    <!-- FOOTER -->
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancelarFormularioImagen()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="onSubmit()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

  </div>
</ng-container>
